// HKDSE 2019 Paper 1 Knowledge Graph Samples
// Organized by question types with systematic naming

export const hkdse2019Samples = {
  algebra: [
    {
      id: 'hkdse2019_algebra_01',
      problem: "Given that $h$ is the subject of the formula $9(h + 6k) = 7h + 8$.",
      problemType: "algebra_formula",
      difficulty: "fundamental",
      description: "Rearranging formula to make a variable the subject",
      graphData: {
        nodes: [
          {
            id: "bracket_expansion",
            name: "Bracket Expansion",
            type: "concepts",
            description: "Expanding brackets using distributive law",
            value: "a(b + c) = ab + ac",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "collecting_terms",
            name: "Collecting Terms",
            type: "concepts",
            description: "Gathering like terms on one side",
            value: "Group terms with same variable",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "step1_expand_bracket",
            name: "Step 1: Expand Bracket",
            type: "steps",
            description: "Expand 9(h + 6k)",
            value: "9h + 54k = 7h + 8",
            importance: 9,
            x: 150, y: -100, z: 20
          },
          {
            id: "step2_collect_terms",
            name: "Step 2: Collect Terms",
            type: "steps",
            description: "Collect all terms with h on one side",
            value: "9h - 7h = 8 - 54k",
            importance: 8,
            x: 0, y: 0, z: 25
          },
          {
            id: "step3_simplify",
            name: "Step 3: Simplify",
            type: "steps",
            description: "Simplify both sides",
            value: "2h = 8 - 54k",
            importance: 8,
            x: 0, y: 100, z: -15
          },
          {
            id: "step4_solve_for_h",
            name: "Step 4: Solve for h",
            type: "steps",
            description: "Divide both sides by 2",
            value: "h = (8 - 54k)/2 = 4 - 27k",
            importance: 10,
            x: 0, y: 200, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "h expressed in terms of k",
            value: "h = 4 - 27k",
            importance: 10,
            x: 0, y: 300, z: 0
          }
        ],
        links: [
          { from: "bracket_expansion", to: "step1_expand_bracket", type: "enables", strength: 10 },
          { from: "collecting_terms", to: "step2_collect_terms", type: "enables", strength: 9 },
          { from: "step1_expand_bracket", to: "step2_collect_terms", type: "leads to", strength: 9 },
          { from: "step2_collect_terms", to: "step3_simplify", type: "leads to", strength: 9 },
          { from: "step3_simplify", to: "step4_solve_for_h", type: "leads to", strength: 10 },
          { from: "step4_solve_for_h", to: "final_answer", type: "equals", strength: 10 }
        ]
      }
    },
    {
      id: 'hkdse2019_algebra_02',
      problem: "Simplify $\\frac{3}{7x - 6} - \\frac{2}{5x - 4}$.",
      problemType: "algebra_fractions",
      difficulty: "intermediate",
      description: "Subtracting algebraic fractions",
      graphData: {
        nodes: [
          {
            id: "common_denominator",
            name: "Common Denominator",
            type: "concepts",
            description: "Finding the least common multiple of denominators",
            value: "LCM of denominators",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "cross_multiplication",
            name: "Cross Multiplication",
            type: "concepts",
            description: "Method for subtracting fractions with different denominators",
            value: "a/b - c/d = (ad - bc)/bd",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "step1_find_lcm",
            name: "Step 1: Find LCM",
            type: "steps",
            description: "Find LCM of (7x-6) and (5x-4)",
            value: "LCM = (7x-6)(5x-4)",
            importance: 8,
            x: 150, y: -100, z: 20
          },
          {
            id: "step2_cross_multiply",
            name: "Step 2: Cross Multiply",
            type: "steps",
            description: "Apply cross multiplication method",
            value: "3(5x-4) - 2(7x-6) / (7x-6)(5x-4)",
            importance: 9,
            x: 0, y: 0, z: 25
          },
          {
            id: "step3_expand",
            name: "Step 3: Expand Numerator",
            type: "steps",
            description: "Expand the numerator",
            value: "(15x-12) - (14x-12) = x",
            importance: 8,
            x: 0, y: 100, z: -15
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "The simplified fraction",
            value: "x/(7x-6)(5x-4)",
            importance: 10,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          { from: "common_denominator", to: "step1_find_lcm", type: "enables", strength: 10 },
          { from: "cross_multiplication", to: "step2_cross_multiply", type: "enables", strength: 9 },
          { from: "step1_find_lcm", to: "step2_cross_multiply", type: "leads to", strength: 10 },
          { from: "step2_cross_multiply", to: "step3_expand", type: "leads to", strength: 9 },
          { from: "step3_expand", to: "final_answer", type: "equals", strength: 10 }
        ]
      }
    }
  ]
}; 